module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/babel-runtime/core-js/get-iterator.js
// module id = ../../../../babel-runtime/core-js/get-iterator.js
// module chunks = 42